import i18next from 'i18next';
import { AvailableLanguages } from '../config/languages';
import { LocalStorageKey } from '../constants/localStorageKeys';
import { RegionTypes } from '../config/regions';

const DETECTED_REGION =
	process.env.REACT_APP_REGION === RegionTypes.SaudiArabia
		? RegionTypes.SaudiArabia
		: RegionTypes.Global;

export class RegionService {
	currentRegion() {
		return DETECTED_REGION;
	}

	onChangeLanguage(lang) {
		localStorage.setItem(LocalStorageKey.investorsCollections, null);
		localStorage.setItem(LocalStorageKey.borrowersCollections, null);

		let pathArray = window.location.pathname.split('/');
		let isAvailable = AvailableLanguages.find(
			(language) => language.lang === lang
		);
		if (isAvailable) {
			i18next.changeLanguage(lang);
			pathArray[1] = lang;
		} else {
			pathArray[1] = AvailableLanguages[0].lang;
			i18next.changeLanguage(AvailableLanguages[0].lang);
		}
		document.body.dir = i18next.dir(lang);
		let newURL = pathArray.join('/');
		window.location.replace(newURL);
	}
}
